export default "__VITE_ASSET__DuQ9QomQ__"